import {
  defineLayoutModule,
  type ViewLayoutModuleContext,
  type ViewLayoutModuleMode
} from '@databases/view-layout-modules';
import { z } from 'zod';

/**
 * Stable identifier persisted for the experimental div-based table layout.
 */
export const TABLE_V2_LAYOUT_ID = 'table-v2' as const;

export type CreateTableV2LayoutModuleOptions = {
  /**
   * Controls whether the registered layout may be written.
   */
  getMode: (context: ViewLayoutModuleContext) => ViewLayoutModuleMode;
};

/**
 * Creates the registered Table V2 layout module.
 *
 * Phase 0 has no durable layout properties. Future properties must add their
 * defaults to this schema so the module remains backward-compatible.
 */
export const createTableV2LayoutModule = ({
  getMode
}: CreateTableV2LayoutModuleOptions) =>
  defineLayoutModule({
    id: TABLE_V2_LAYOUT_ID,
    schema: z.object({}),
    getMode
  });
